import React, { Component } from 'react'
import Select from 'react-select';

const options = [
  { value: '1', label: 'Januari' },
  { value: '2', label: 'Februari' },
  { value: '3', label: 'Mars' },
  { value: '4', label: 'April'},
  { value: '5', label: 'Maj'},
  { value: '6', label: 'Juni'},
  { value: '7', label: 'Juli'},
  { value: '8', label: 'Augusti'},
  { value: '9', label: 'September'},
  { value: '10', label: 'October'},
  { value: '11', label: 'November'},
  { value: '12', label: 'December'}
];

class CartMonthSelect extends Component{

  render() {
    return(
      <div className="Admin-CartMonth">
        <Select
          value={this.props.month}
          onChange={this.props.handleMonthChange}
          options={options}
        />
      </div>
    )
  }
}

export default CartMonthSelect



// WEBPACK FOOTER //
// ./src/containers/admin/components/CartMonthSelect.jsx